import { render, staticRenderFns } from "./opened-tickets.vue?vue&type=template&id=23ff0e1c"
import script from "./opened-tickets.vue?vue&type=script&lang=js"
export * from "./opened-tickets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports